export enum AddressScreenType {
  HOME = 'homeAddressScreen',
  MAILING = 'mailingAddressScreen',
}
